/* tslint:disable */
/* eslint-disable */
/**
 * ProjectOne API
 * API for Classical Conversations content and communities.  # Service URLs In local dev: - [The **local backend**](http://0.0.0.0:8080/) defaults to running on port 8080. - [The **local frontend**](http://0.0.0.0:3000/) defaults to running on port 3000.  In the DEV environment: - [The **DEV backend**](https://dev-ccp1-api.classicaltesting.net/) runs at https://dev-ccp1-api.classicaltesting.net/. - [The **DEV frontend**](https://dev-ccp1.classicaltesting.net/) runs at https://dev-ccp1.classicaltesting.net/.  The TEST environment is similar, but with `test-` instead of `dev-`.
 *
 * The version of the OpenAPI document: ea99bacb (Fri Jun  5 23:34:18 UTC 2026)
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 * @interface BulkReassignEventsRequestBody
 */
export interface BulkReassignEventsRequestBody {
  /**
   * Unique identifier of the actor to whom all of the events will be reassigned.
   * @type number
   * @memberof BulkReassignEventsRequestBody
   */
  newEventOwnerKey: number
  /**
   * The list of unique identifiers of events to reassign to the newEventOwnerKey.
   * @type {Array<number>}
   * @memberof BulkReassignEventsRequestBody
   */
  eventKeysToReassign: Array<number>
}

export function BulkReassignEventsRequestBodyFromJSON(
  json: any
): BulkReassignEventsRequestBody {
  return BulkReassignEventsRequestBodyFromJSONTyped(json, false)
}

export function BulkReassignEventsRequestBodyFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): BulkReassignEventsRequestBody {
  if (json === undefined || json === null) {
    return json
  }
  return {
    newEventOwnerKey: json['newEventOwnerKey'],
    eventKeysToReassign: json['eventKeysToReassign'],
  }
}

export function BulkReassignEventsRequestBodyToJSON(
  value?: BulkReassignEventsRequestBody | null
): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    newEventOwnerKey: value.newEventOwnerKey,
    eventKeysToReassign: value.eventKeysToReassign,
  }
}
